module.exports = __webpack_public_path__ + "static/media/acidyellow219401004.0f755d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/acidyellow219401004.png
// module id = 496
// module chunks = 0